let streamingActive = false;

export function setStreamingActiveMirror(value: boolean): void {
  streamingActive = value;
}

export function getStreamingActiveMirror(): boolean {
  return streamingActive;
}
